import request from "../composables/useHttp";

/**
 * @description: 获取信息公开列表
 * @param: {number} typeId : 1.通知公告  2.公示公告
 * */
export function getGG(typeId, page, pageSize) {
    return request("/info-notice/gw/findGWInfoNotices", {
        method: 'get',
        params: {typeId, page, pageSize}
    })
}


/**
 * @description: 获取信息公开详情
 * @param: {number} infoNoticeId : 公告id
 * */
export function getGGDetail(infoNoticeId ) {
    return request("/info-notice/gw/findGWInfoNoticeDetail", {
        method: 'get',
        params: {infoNoticeId}
    })
}
